import { render, staticRenderFns } from "./items_by_date_table.vue?vue&type=template&id=e128c638&"
import script from "./items_by_date_table.vue?vue&type=script&lang=js&"
export * from "./items_by_date_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports